<template>
  <div>

    <button
      class="Fuell-IconButton Fuell-IconButton--header Fuell-Menu-ToggleButton"
      @click="toggleSidebar"
      aria-hidden="true"
    >
      <img
        v-if="!openSidebarFlag"
        :src="require('@/assets/img/icons/burger-menu.svg')"
        alt="menu"
        role="button"
      >
      <img
        v-else
        :src="require('@/assets/img/icons/close-menu.svg')"
        alt="menu"
        role="button"
      >
    </button>
    <div
      class="Fuell-Header justify-content-between"
      :class="{'Fuell-Header--open-sidebar' : openSidebarFlag}"
    >
      <div class="Fuell-Header--container-title">
        <router-link to='/dashboard'>
          <img
            class="Fuell-Logo header-logo"
            :src="require('@/assets/img/logo.svg')"
            focusable="false"
            aria-hidden="true"
            alt="menu"
          >
        </router-link>

        <h1 class="Fuell-Header--title">
          <router-link :to="`/${$route.meta.section}`"> {{ $t(currentSectionLabelRender) }}</router-link>
          <span v-if="currentSectionBreadcrumb">
            {{ currentSectionBreadcrumbRendderLabel }}
          </span>
        </h1>
      </div>
      <transactions-dashboard />
    </div>

    <aside
      class="Fuell-Menu"
      :class="{'Fuell-Menu--open-sidebar' : openSidebarFlag}"
    >
      <dashboard-side-menu :isOpen.sync="openSidebarFlag">
      </dashboard-side-menu>
    </aside>

    <div
      class="Fuell-Container"
      :class="{'Fuell-Container--open-sidebar' : openSidebarFlag}"
    >
      <user-impersonate-bar v-if="isImpersonatingUser" />
      <router-view></router-view>
    </div>

    <!--- DEFINICIONES DE IMAGENES  Mover a componentes-->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      data-url=""
      style="display: none;"
    >
      <!-- ICONOS 16 -->

      <!-- ************ SEARCH *************** -->
      <symbol
        id="search-icon"
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
      >
        <g
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="element/icon/16/down-copy-9"
            stroke="#5E6D7C"
          >
            <g
              id="Group"
              transform="translate(2.000000, 2.000000)"
            >
              <line
                x1="8"
                y1="12"
                x2="12"
                y2="8"
                id="Path-4-Copy"
                transform="translate(10.000000, 10.000000) scale(-1, 1) translate(-10.000000, -10.000000) "
              ></line>
              <circle
                id="Oval"
                cx="5"
                cy="5"
                r="4.5"
              ></circle>
            </g>
          </g>
        </g>
      </symbol>
      <!-- ************ FILTER *************** -->
      <symbol
        id="filter-icon"
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
      >
        <g
          id="Symbols"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="element/icon/16/filter"
            stroke="#5E6D7C"
          >
            <path
              d="M3.81727365,2 L12.1795136,2 C12.7317984,2 13.1795136,2.44771525 13.1795136,3 C13.1795136,3.18999699 13.1253868,3.37606226 13.0234702,3.53641147 L9.48937674,9.09673537 C9.38746017,9.25708459 9.33333333,9.44314985 9.33333333,9.63314684 L9.33333333,12.509288 C9.33333333,13.0181139 8.92084849,13.4305987 8.41202266,13.4305987 C8.2689937,13.4305987 8.12792899,13.3972978 8,13.3333333 L7.21945307,12.9430599 C6.88066904,12.7736679 6.66666667,12.4274047 6.66666667,12.0486327 L6.66666667,9.65658332 C6.66666667,9.46709353 6.6128282,9.28150369 6.51142232,9.12143112 L2.97251799,3.5351522 C2.6769616,3.06860653 2.81557578,2.45080074 3.28212145,2.15524434 C3.44219403,2.05383846 3.62778386,2 3.81727365,2 Z"
              id="Rectangle"
            ></path>
          </g>
        </g>
      </symbol>
      <!-- ************ DROPDOWN *************** -->
      <symbol
        id="dropdown-icon"
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
      >
        <g
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="element/icon/16/down"
            stroke="#5E6D7C"
          >
            <polyline
              id="Path-2"
              points="4 6 8 10 12 6"
            ></polyline>
          </g>
        </g>
      </symbol>
      <!-- ************ ARROWRIGHT ************** -->
      <symbol
        id="arrowright-icon"
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
      >
        <g
          id="Symbols"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="element/icon/16/down-copy-6"
            stroke="#5E6D7C"
          >
            <polyline
              id="Path-2"
              transform="translate(12.000000, 8.000000) rotate(-90.000000) translate(-12.000000, -8.000000) "
              points="8 6 12 10 16 6"
            ></polyline>
          </g>
        </g>
      </symbol>
      <!-- ************ CLOSE *************** -->
      <symbol
        id="close-icon"
        viewBox="0 0 16 16"
      >
        <g
          id="Symbols"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="element/icon/16/down-copy-8"
            stroke="#5E6D7C"
          >
            <line
              x1="4"
              y1="12"
              x2="12"
              y2="4"
              id="Path-4"
            ></line>
            <line
              x1="4"
              y1="12"
              x2="12"
              y2="4"
              id="Path-4-Copy"
              transform="translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000) "
            ></line>
          </g>
        </g>
      </symbol>
      <!-- ICONOS 24 -->

      <!-- ************ ACTIONS *************** -->
      <symbol
        id="actions-icon"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
      >
        <g
          id="Symbols"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          fill-opacity="1"
        >
          <g
            id="element/icon/24/camera-copy-23"
            fill="#5E6D7C"
          >
            <circle
              id="Oval"
              cx="12"
              cy="6"
              r="2"
            ></circle>
            <circle
              id="Oval-Copy"
              cx="12"
              cy="12"
              r="2"
            ></circle>
            <circle
              id="Oval-Copy-2"
              cx="12"
              cy="18"
              r="2"
            ></circle>
          </g>
        </g>
      </symbol>

      <!-- ********** TICKET ****************** -->
      <symbol
        id="actions-icon"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
      >
        <g id="ticket">
          <path
            d="M15,17.7071068 L12,20.7071068 L9,17.7071068 L5.5,21.2071068 L5.5,4.5 L18.5,4.5 L18.5,21.2071068 L15,17.7071068 Z"
            id="Path-11"
            stroke="#6B7C8D"
            stroke-linejoin="round"
          ></path>
          <path
            d="M8.5,7 L15.5,7 C15.7761424,7 16,7.22385763 16,7.5 C16,7.77614237 15.7761424,8 15.5,8 L8.5,8 C8.22385763,8 8,7.77614237 8,7.5 C8,7.22385763 8.22385763,7 8.5,7 Z"
            id="Rectangle"
            fill="#6B7C8D"
          ></path>
          <path
            d="M8.5,10 L11.5,10 C11.7761424,10 12,10.2238576 12,10.5 C12,10.7761424 11.7761424,11 11.5,11 L8.5,11 C8.22385763,11 8,10.7761424 8,10.5 C8,10.2238576 8.22385763,10 8.5,10 Z"
            id="Rectangle-Copy"
            fill="#6B7C8D"
          ></path>
        </g>
      </symbol>
    </svg>
    <!----------->

    <!-------------------------------->

  </div>

</template>

<style scoped>
.header-logo {
  margin-left: 25px;
}
</style>

<script>
import DashboardSideMenu from '../components/Dashboard/DashboardSideMenu'
import UserImpersonateBar from '@/components/Commons/UserImpersonateBar'
import TransactionsDashboard from '@/modules/transactions/_components/_shared/TransactionsDashboard'

import { capitalize } from 'lodash-es'
export default {
  name: 'LayoutDashboard',
  components: { DashboardSideMenu, UserImpersonateBar, TransactionsDashboard },
  computed: {
    currentSectionLabelRender () {
      if (this.$route.meta.alternateNameLabel) {
        return this.$route.meta.alternateNameLabel
      }
      return this.$route.name ? `section_title_${this.$route.name}` : ''
    },
    currentSectionBreadcrumb () {
      return this.$route.meta.breadcrumb ? this.$route.meta.breadcrumb : false
    },
    currentSectionBreadcrumbRendderLabel () {
      if (this.currentSectionBreadcrumb) {
        switch (this.currentSectionBreadcrumb) {
          case 'user': {
            const user = this.$store.getters['UsersStore/users'].find(el => el.id === Number.parseInt(this.$route.params.id))
            if (user) {
              return `> ${user.firstName} ${user.lastName}`
            } else {
              return ''
            }
          }
          case 'budget': {
            const budget = this.$store.getters['BudgetsStore/currentBudget']
            if (budget && budget.name) {
              return `> ${budget.name}`
            } else {
              return ''
            }
          }
          case 'integration': {
            const integrationName = this.$route.params.erp
            if (integrationName) {
              return `> ${capitalize(integrationName)}`
            }
            return ''
          }
          case 'expenses': {
            return this.$route.meta.breadcrumbLabel ? ` > ${this.$t(this.$route.meta.breadcrumbLabel)} ` : ''
          }
          case 'reimbursements': {
            let list = this.$store.getters['TransactionsStore/users'].length > 0 ? this.$store.getters['TransactionsStore/users'] : this.$store.getters['TransactionsStore/transactions']
            const user = list.find(el => el.card?.user?.id === Number.parseInt(this.$route.params.userId) || el.user_id === Number.parseInt(this.$route.params.userId))
            if (user) {
              return user.user_first_name ? `> ${user.user_first_name} ${user.user_last_name}` : `${user.card.user.firstName} ${user.card.user.lastName}`
            } else {
              return ''
            }
          }
          default: {
            return ''
          }
        }
      } else {
        return ''
      }
    },
    isImpersonatingUser () {
      return this.$store.getters['LoginStore/isImpersonating']
    },
    currentLoggedUser () {
      return this.$store.getters['LoginStore/user']
    },
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    isSuperAdmin () {
      return this.$store.getters['LoginStore/isSuperAdmin']
    },
    isBookKeeper () {
      return this.$store.getters['LoginStore/isBookKeeper']
    }
  },
  data () {
    return {
      openSidebarFlag: false
    }
  },
  methods: {
    toggleSidebar () {
      this.openSidebarFlag = !this.openSidebarFlag
      this.$store.dispatch('GlobalStore/setSideMenuIsOpen', this.openSidebarFlag)
    },
    goToProfile () {
      this.$router.push('/profile')
    }
  },
  watch: {
    '$route' (to, from) {
        if (this.openSidebarFlag) {
          this.openSidebarFlag = false
          this.$store.dispatch('GlobalStore/setSideMenuIsOpen', this.openSidebarFlag)
        }
    }
  }

}
</script>
